<template>
  <div class="multiselect-options">
    <div v-for="option in props.options" :key="`option-${option[keyMap.value]}`" :class="multiselectOptionClasses(option)">
      <div class="multiselect-option-label t single-line" @click.stop.prevent>{{ option[keyMap.label] }}</div>
      <div v-if="!optionIsUnremovable(option)" class="multiselect-option-deselect t" @click.stop.prevent="onRemoveSelectionClick(option)">
        <i class="mi md-18">close</i>
      </div>
    </div>
    <slot />
  </div>
</template>

<script setup>
  const props = defineProps({
    options: { type: Array, required: true },
    keyMap: { type: Object, default: null },
    minSelections: { type: Number, default: null },
  });
  const emit = defineEmits(['onRemoveSelectionClick']);
  const onRemoveSelectionClick = (option) => { emit('onRemoveSelectionClick', option); };

  const optionIsUnremovable = (_option) => {
    if (props.minSelections) return props.options.length <= props.minSelections;
  };
  const multiselectOptionClasses = (option) => ({
      'multiselect-option': true,
      unremovable: optionIsUnremovable(option),
    });
</script>
